import React, { useEffect, useState } from 'react';

/**
 * Service Worker Update Handler
 * Detecteert wanneer een nieuwe versie van de app beschikbaar is
 * en notificeert de gebruiker
 */
const ServiceWorkerUpdate = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    // Check for service worker updates every 60 seconds
    const interval = setInterval(() => {
      if (navigator.serviceWorker) {
        navigator.serviceWorker.ready.then(registration => {
          registration.update();
        });
      }
    }, 60000); // 60 seconds

    // Listen for service worker updates
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        console.log('✅ New Service Worker activated - app has been updated');
        window.location.reload();
      });

      navigator.serviceWorker.ready.then(registration => {
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;

          newWorker.addEventListener('statechange', () => {
            // New service worker is ready
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('📢 New app version available');
              setUpdateAvailable(true);
            }
          });
        });
      });
    }

    return () => clearInterval(interval);
  }, []);

  const handleUpdate = () => {
    if (navigator.serviceWorker && navigator.serviceWorker.controller) {
      // Send update message to service worker
      navigator.serviceWorker.controller.postMessage({
        type: 'SKIP_WAITING'
      });
      setUpdateAvailable(false);
    }
  };

  if (!updateAvailable) return null;

  return (
    <div className="alert alert-info alert-dismissible fixed-top m-3" role="alert" style={{ zIndex: 9999 }}>
      <button type="button" className="btn-close" onClick={() => setUpdateAvailable(false)}></button>
      <strong>🔄 Nieuwe versie beschikbaar!</strong>
      <p>Er is een nieuwe versie van de app beschikbaar. Klik op "Updaten" om de wijzigingen door te voeren.</p>
      <button
        className="btn btn-primary btn-sm"
        onClick={handleUpdate}
      >
        Updaten
      </button>
    </div>
  );
};

export default ServiceWorkerUpdate;
